module.exports = __webpack_public_path__ + "img/airline_seat_flat_angled.eb675659.svg";